import { render, staticRenderFns } from "./DetailRating.vue?vue&type=template&id=754ac48c"
import script from "./DetailRating.vue?vue&type=script&lang=js"
export * from "./DetailRating.vue?vue&type=script&lang=js"
import style0 from "./DetailRating.vue?vue&type=style&index=0&id=754ac48c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports